module.exports = __webpack_public_path__ + "img/bg_gongzuodongtai.3d168dee.png";